(function ($) {

  Drupal.behaviors.responsive_filters = {
    attach: function (context, settings) {


      var $body = $('body');

      if(!$body.hasClass('responsive-filters') && $body.hasClass('path-search-products')) {

        var $layoutBeforeContent = $('.layout-before-content');
        var $regionBeforeContent = $('.region-before-content');

        $layoutBeforeContent.prepend('<div id="responsive-filters-bar"><div class="responsive-filters">Filtra</div></div>');

        var $filtersButton = $('.responsive-filters');

        $filtersButton.click(function(e) {
          $regionBeforeContent.toggleClass('open');
        });

        $body.addClass('responsive-filters');
      }


    }
  };

})(jQuery);
